import { forwardRef } from 'react';
import {
  Paper as MUIPaper, PaperProps as MUIPaperProps,
} from '@mui/material';
import classNames from 'classnames';
import { boxShadow2, AB3 } from '../../theme';
import { ColorTypeEnum } from '../../enums';
import { mergeSX } from '../../services/helpers';

export { default as PanelHeader, type IPanelHeaderProps } from './components/PanelHeader';
export { default as PanelContent, type IPanelContentProps } from './components/PanelContent';

const buildSX = () => ({
  '&.MuiPaper-root': {
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: boxShadow2,
    '&.secondary': {
      backgroundColor: AB3,
    },
  },
});

export interface IPanelProps extends MUIPaperProps {
  color?: ColorTypeEnum;
}

const Panel = forwardRef<HTMLDivElement, IPanelProps>((props, ref) => {
  const {
    children, color = ColorTypeEnum.Primary, className, sx, ...rest
  } = props;

  return (
    <MUIPaper
      className={classNames(className, {
        primary: color === ColorTypeEnum.Primary,
        secondary: color === ColorTypeEnum.Secondary,
      })}
      ref={ref}
      sx={mergeSX(buildSX(), sx)}
      {...rest}
    >
      {children}
    </MUIPaper>
  );
});

export default Panel;
